import { CellContent, FlexCellContent, Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import { EntityIconTableMuted30 } from '@components/core-ui/EntityIcon/variations/EntityIconTableMuted30';
import { IconButtonRegular } from '@components/core-ui/form-elements/buttons/IconButton/variations/IconButtonRegular';
import { IconButtonDelete } from '@components/core-ui/form-elements/buttons/IconButton/variations/IconButtonDelete';
import { showcasePagePanelClassName } from '@pages/Admin/ComponentShowcasePage/helpers/showcasePagePanelClassName';
import { showcaseSurfacePanelClassName } from '@pages/Admin/ComponentShowcasePage/helpers/showcaseSurfacePanelClassName';
import EditIcon from '@components/icons/Edit.svg';
import TrashBin from '@components/icons/TrashBin.svg';

const sampleRows = [
  { id: '1', name: 'Jane Doe', email: 'jane@example.com', phone: '+1 555 0100', status: 'Active' },
  { id: '2', name: 'John Smith', email: 'john@example.com', phone: '+1 555 0101', status: 'Pending' },
  { id: '3', name: 'Alex Lee', email: 'alex@example.com', phone: '+1 555 0102', status: 'Inactive' },
];

const variantLabelClassName = 'mb-2 text-xs font-medium text-foreground-muted';

const noop = () => undefined;

const SampleTable = ({ forModal }: { forModal: boolean }) => (
  <TableWrapper>
    <Table>
      <Thead {...(forModal ? { $white: true } : {})}>
        <Tr>
          <Th style={{ width: '1%' }} />
          <Th>Name</Th>
          <Th>Contact</Th>
          <Th>Status</Th>
          <Th>Actions</Th>
        </Tr>
      </Thead>
      <Tbody>
        {sampleRows.map((row) => (
          <Tr key={row.id}>
            <Td>
              <FlexCellContent>
                <EntityIconTableMuted30 name={row.name} />
              </FlexCellContent>
            </Td>
            <Td>
              <FlexCellContent>{row.name}</FlexCellContent>
            </Td>
            <Td>
              <FlexCellContent>
                <CellContent>
                  <span className="block">{row.email}</span>
                  <span className="block">{row.phone}</span>
                </CellContent>
              </FlexCellContent>
            </Td>
            <Td>
              <FlexCellContent>{row.status}</FlexCellContent>
            </Td>
            <Td>
              <FlexCellContent>
                <CellContent>
                  <div className="flex gap-1">
                    <IconButtonRegular title="Edit" onClick={noop}>
                      <EditIcon />
                    </IconButtonRegular>
                    <IconButtonDelete title="Remove" onClick={noop}>
                      <TrashBin />
                    </IconButtonDelete>
                  </div>
                </CellContent>
              </FlexCellContent>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  </TableWrapper>
);

export const TableDemo = () => (
  <div className="flex flex-col gap-8">
    <div>
      <p className={variantLabelClassName}>On page background</p>
      <div className={showcasePagePanelClassName}>
        <SampleTable forModal={false} />
      </div>
    </div>
    <div>
      <p className={variantLabelClassName}>On surface (modal)</p>
      <div className={showcaseSurfacePanelClassName}>
        <SampleTable forModal />
      </div>
    </div>
  </div>
);
